
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import Teleport from '@xt/client/mixins/components/teleport.vue'

@Observer
@Component({
  name: 'FinalModal',
  inheritAttrs: false,
  components: { Teleport }
})
export default class FinalModal extends Vue {
  get mergedProps() {
    const defaultProps = {
      ssr: false,
      attach: false,
      classes: 'modal-container',
      contentClass: 'modal-content',
      zIndex: 1002
    }

    return Object.assign({}, defaultProps, this.$attrs)
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
